import get from 'lodash/get';

export const getNavigationHistory = state => get(state, 'page.navigation.history', []);
